import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Skeleton from '@mui/material/Skeleton';
import { withStyles } from 'tss-react/mui';
import React, { Component } from 'react';
import { isWebpSupported } from 'react-image-webp/dist/utils';
import LazyLoad from 'react-lazyload';
import imageCrop from 'helpers/imageCrop';
import shadow from '../../helpers/shadow';
import { getUser } from '../../helpers/token';
import Link from '@mui/material/Link';
import RoundNavIconBtn from '../Header/RoundNavIconBtn';
import DotMenu from '../Post/DotMenu';
import SubHeader from '../Post/SubHeader';
import VoteSlider from '../Post/VoteSlider';
import ProfileAvatar from '../Profile/ProfileAvatar';
import ProfileName from '../Profile/ProfileName';
import Excerpt from './Excerpt';
import Image from 'components/Image';

const styles = () => ({
  card: {
    borderRadius: 12,
    boxShadow: shadow.lg,
  },
  cardHeader: {
    padding: 12,
  },
});

class GridPostCard extends Component {
  constructor(props) {
    super(props);
    this.myInput = React.createRef();
  }

  state = { show: true, cardWidth: undefined, isWebp: undefined };

  async componentDidMount() {
    if (this.myInput.current) {
      const cardWidth = Math.ceil(this.myInput.current.offsetWidth / 100) * 100;
      this.setState({ cardWidth });
    }
    const isWebp = isWebpSupported();
    this.setState({ isWebp });
  }

  hide = () => {
    this.setState({ show: false });
  };

  render() {
    const { classes, post } = this.props;
    // eslint-disable-next-line one-var
    let author,
      permlink,
      tags,
      thumb,
      title,
      createdAt,
      location,
      readTime,
      wordCount,
      excerpt,
      totalSmiles,
      comments,
      smiles,
      username,
      community,
      avatar;

    // Hide if deleted (for bookmarks)
    if (!this.state.show) {
      return <></>;
    }
    let isSkeleton;
    if (!post) isSkeleton = true;
    else {
      author = post.author;
      permlink = post.permlink;
      tags = post.tags;
      thumb = post.thumb;
      title = post.title;
      createdAt = post.createdAt;
      location = post.location;
      readTime = post.readTime;
      wordCount = post.wordCount;
      excerpt = post.excerpt;
      totalSmiles = post.totalSmiles;
      comments = post.comments;
      smiles = post.smiles;
      community = post.community;
      username = author.username;
      avatar = author.avatar;
    }

    return (
      <Card
        key={isSkeleton ? 'loadercard' : permlink}
        className={`mb-0 mt-2 mr-2 ml-2 ${classes.card}`}
      >
        <CardHeader
          className={classes.cardHeader}
          avatar={
            isSkeleton ? (
              <Skeleton variant="circular" width={40} height={40} />
            ) : (
              <Link href={`/@${username}`}>
                <RoundNavIconBtn style={{ padding: 0 }}>
                  <ProfileAvatar authorAvatar={avatar} author={username} />
                </RoundNavIconBtn>
              </Link>
            )
          }
          action={
            isSkeleton ? (
              <></>
            ) : (
              <>
                <DotMenu
                  editLink={
                    getUser() === username
                      ? `/dashboard/publish?permlink=${encodeURIComponent(
                          permlink,
                        )}`
                      : undefined
                  }
                  alwaysShowSaveBtn={this.props.hideSaveBtn}
                  author={username}
                  permlink={permlink}
                  title={title}
                  thumbnail={thumb ? thumb.url : undefined}
                  tags={tags}
                  onBmChange={this.props.isBookmark ? this.hide : undefined}
                />
              </>
            )
          }
          title={
            isSkeleton ? (
              <Skeleton variant="text" width={200} height={17} />
            ) : (
              <ProfileName author={author} />
            )
          }
          subheader={
            isSkeleton ? (
              <Skeleton variant="text" width="90%" height={17} />
            ) : (
              <SubHeader
                createdAt={createdAt}
                readTime={readTime}
                wordCount={wordCount}
                location={location}
                tags={tags}
                community={community}
              />
            )
          }
        />
        {isSkeleton ? (
          <>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={this.props.cardHeight}
            />
            <CardContent>
              <Skeleton
                variant="text"
                width="100%"
                height={40}
                className="pb-3"
              />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="100%" height={20} />
            </CardContent>
          </>
        ) : (
          <>
            <Link color="textPrimary" href={`/@${username}/${permlink}`}>
              <CardActionArea>
                {thumb && thumb.url && (
                  <div ref={this.myInput}>
                    {(post.youtubeId && (
                      <LazyLoad
                        unmountIfInvisible
                        offset={400}
                        height={this.props.cardHeight}
                        placeholder={
                          <Skeleton
                            className="fullwidth"
                            variant="rectangular"
                            width="100%"
                            height={this.props.cardHeight}
                          />
                        }
                      >
                        <iframe
                          title="Cover Video"
                          className="embed-resonsive w-100"
                          height={this.props.cardHeight}
                          src={`https://www.youtube-nocookie.com/embed/${post.youtubeId}?autoplay=1&mute=1&modestbranding=1&rel=0&iv_load_policy=3&loop=1&showinfo=0`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        />
                      </LazyLoad>
                    )) || (
                        <div
                          className="tw-relative tw-w-full"
                          style={{
                            height: this.props.cardHeight,
                          }}
                        >
                          <Image
                            unoptimized
                            className="tw-object-cover tw-object-center"
                            src={imageCrop(thumb.url, 1210, 660)}
                            layout="fill"
                            alt={post.title}
                            blurDataURL={thumb.blur}
                            placeholder={thumb.blur ? 'blur' : undefined}
                          />
                        </div>
                      ) || (
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={this.props.cardHeight}
                        />
                      )}
                  </div>
                )}
                <CardContent>
                  <Excerpt title={title} text={excerpt} />
                </CardContent>
              </CardActionArea>
            </Link>
            <VoteSlider
              hideSaveBtn={this.props.hideSaveBtn}
              onBmChange={this.props.isBookmark ? this.hide : undefined}
              author={username}
              permlink={permlink}
              smiles={smiles}
              totalSmiles={totalSmiles}
              noOfComments={comments}
              mode="gridcard"
            />
          </>
        )}
      </Card>
    );
  }
}

export default withStyles(GridPostCard, styles);
